import { render } from "./CreateProjectVariable.vue?vue&type=template&id=87deafba"
import script from "./CreateProjectVariable.vue?vue&type=script&lang=js"
export * from "./CreateProjectVariable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/CreateProjectVariable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "87deafba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('87deafba', __exports__)) {
    api.reload('87deafba', __exports__)
  }
  
  module.hot.accept("./CreateProjectVariable.vue?vue&type=template&id=87deafba", () => {
    api.rerender('87deafba', render)
  })

}


export default __exports__